var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 960,
    viewBox: "0 0 543 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.6827 326.826L31.0633 373.602C101.519 445.366 145.002 543.749 145.002 652.303C364.501 652.303 542.443 474.235 542.443 254.58C542.443 144.768 497.97 45.3499 426.064 -26.6193L426.036 -26.5914L381.759 -70.8971C272.313 -180.423 94.9706 -180.768 -14.9033 -71.6739H-14.9064C-125.389 38.0293 -125.737 216.694 -15.6827 326.826Z",
    fill: "#FFBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.71222 98.3105L-52.455 51.5346C-122.914 -20.2326 -166.397 -118.613 -166.397 -227.17C-166.397 -334.875 -123.591 -432.565 -54.1038 -504.18L-54.0789 -504.246L-443.277 -114.772L-443.212 -114.797C-517.598 -42.5205 -563.838 58.6066 -563.838 170.553C-563.838 280.368 -519.362 379.783 -447.459 451.756L-447.428 451.728L-403.154 496.033C-293.705 605.559 -116.366 605.904 -6.48846 496.81C103.994 387.107 104.342 208.443 -5.71222 98.3105Z",
    fill: "#841DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-180.259 491.512L-133.516 538.288C-61.8 608.797 36.5108 652.307 144.991 652.307C252.62 652.307 350.241 609.474 421.805 539.938L421.874 539.91L32.673 929.386L32.6978 929.321C-39.5247 1003.76 -140.58 1050.03 -252.451 1050.03C-362.185 1050.03 -461.533 1005.53 -533.454 933.572L-533.426 933.541L-577.701 889.235C-687.149 779.709 -687.494 602.244 -578.477 492.289H-578.474C-468.851 381.728 -290.313 381.38 -180.259 491.512Z",
    fill: "#FF544D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBgLeft);
export default __webpack_public_path__ + "static/media/home-bg-left.ae2dd67f.svg";
export { ForwardRef as ReactComponent };